export default "__VITE_ASSET__Dmeh6Wvb__"